import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from './logo.png';
import AccessibilityMenu from './components/AccessibilityMenu';
import './App.css';

function Navbar({ theme, toggleTheme }) {
  const [isAccessibilityMenuOpen, setIsAccessibilityMenuOpen] = useState(false);

  // Funzione per mostrare l'icona corretta nel pulsante
  const getThemeIcon = () => {
    if (theme === 'light') return '☀️';
    if (theme === 'dark') return '🌙';
    return '🌓'; // Icona per la modalità Auto
  };

  const getThemeLabel = () => {
    if (theme === 'light') return 'Passa a modalità scura';
    if (theme === 'dark') return 'Passa a modalità auto';
    return 'Passa a modalità chiara';
  };

  return (
    <nav className="navbar" role="navigation" aria-label="Navigazione principale">
      <div className="logo">
        <Link to="/" aria-label="Torna alla homepage">
          <img src={logo} alt="Giovanni Rampazzo logo" className="my-logo" />
        </Link>
      </div>

      <div className="nav-right">
        {/* PULSANTE CAMBIO TEMA */}
        <button
          onClick={toggleTheme}
          className="theme-toggle"
          aria-label={getThemeLabel()}
          title={getThemeLabel()}
        >
          <span aria-hidden="true">{getThemeIcon()}</span>
        </button>

        {/* PULSANTE ACCESSIBILITÀ */}
        <button
          onClick={() => setIsAccessibilityMenuOpen(true)}
          className="theme-toggle accessibility-toggle"
          aria-label="Apri impostazioni accessibilità"
          title="Impostazioni Accessibilità"
        >
          <span aria-hidden="true" style={{ fontWeight: 'bold', fontSize: '1.6rem' }}>A</span>
        </button>

        <Link
          to="/about"
          className="btn-secondary"
          style={{ marginRight: '10px', border: 'none' }}
        >
          Chi Sono
        </Link>
        <Link to="/contact" className="btn-primary">
          Contattami
        </Link>
      </div>

      {/* MENU ACCESSIBILITÀ */}
      <AccessibilityMenu
        isOpen={isAccessibilityMenuOpen}
        onClose={() => setIsAccessibilityMenuOpen(false)}
      />
    </nav>
  );
}

export default Navbar;